import styled from "@emotion/styled";
import React from "react";
import { logoutMSAL } from "auth/MsalAuth";

function ErrorPage() {
  return (
    <MainContainer>
      <Content>
        <Title>Access Unavailable</Title>
        <Desc>You currently do not have access to the LIFT ROI Platform.</Desc>
        <Action>
          <span onClick={() => logoutMSAL()}></span>
        </Action>
        <NeedHelp>Please reach out to your local Kantar contact for assistance.</NeedHelp>
      </Content>
      <div style={{ height: "12rem", width: "12rem" }}>
        <AlertIcon />
      </div>
    </MainContainer>
  );
}

const AlertIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="alert-triangle">
      <path
        id="Vector"
        d="M102.9 38.6L18.2 180C16.4537 183.024 15.5297 186.453 15.5199 189.945C15.5101 193.437 16.4149 196.871 18.1443 199.905C19.8736 202.939 22.3673 205.467 25.3771 207.238C28.3869 209.01 31.808 209.962 35.3 210H204.7C208.192 209.962 211.613 209.01 214.623 207.238C217.633 205.467 220.126 202.939 221.856 199.905C223.585 196.871 224.49 193.437 224.48 189.945C224.47 186.453 223.546 183.024 221.8 180L137.1 38.6C135.317 35.661 132.807 33.2312 129.812 31.5448C126.817 29.8585 123.437 28.9725 120 28.9725C116.563 28.9725 113.183 29.8585 110.188 31.5448C107.193 33.2312 104.683 35.661 102.9 38.6V38.6Z"
        stroke="#323232"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M120 100V140"
        stroke="#323232"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M120 170H120.1"
        stroke="#323232"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const MainContainer = styled("div")`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 6.25rem min(8vw, 5.625rem);
  width: 100vw;
  background: rgba(250, 250, 250, 1);
  word-break: break-word;
  height: 100vh;
`;

const Content = styled("div")`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 0.3125rem 0px;
`;

const Title = styled("div")`
  color: #000;
  font-size: 1.5rem;
  font-weight: 700;
`;

const Desc = styled("div")`
  color: #000;
  font-size: 5rem;
  font-weight: 250;
`;

const Action = styled("div")`
  color: #131321;
  font-size: 1.375rem;
  margin-top: 1.875rem;
  span {
    text-decoration-line: underline;
    color: rgba(112, 35, 168, 1);
    cursor: pointer;
  }
`;

const NeedHelp = styled("div")`
  color: #000;
  font-size: 1.375rem;
  margin-top: 1.875rem;
`;

export default ErrorPage;
